/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'ui-component-library';
import InfoSection from '../../common/card-shared-components/card-info-section';

import TransitTrackerConnection from './transit-tracker-connection';
import Activity from '../../common/activities/activity';
import loadShape from '../../../../shapes/load';
import trackingEventShape from '../../../../shapes/tracking-event-activity';
import InfoTooltipButton from '../../common/info-tooltip-button/info-tooltip-button';
import { TOOLTIP_MESSAGES } from '../../../../constants';
import HeaderDetailsItem from '../../common/header-details-item';
import { StopInformation } from './transit-tracker.style';
import { getCityStateNextStop } from '../../../../utils/mappers';
/**
 * The transit tracker component
 * @param {object} props - Object containing the props for this component
 * @param {array} props.load - The specified load
 * @param {object} props.lastTrackingEvent - The  Last Tracking Event for the load
 * @param {func} props.refetchLoad - Function that handles refetching a load
 * @return {element}
 */
const TransitTracker = ({ load, lastTrackingEvent, refetchLoad }) => (
  <div data-testid="transit-tracker">
    <Card
      title="Transit Tracker"
      headerContent={<InfoTooltipButton text={TOOLTIP_MESSAGES['transit-tracker']} isPrimary />}
      isPaddingRemoved
    >
      <InfoSection removePadding>
        <TransitTrackerConnection load={load} refetchLoad={refetchLoad} />
      </InfoSection>
      <InfoSection
        outlineBottom
        removePadding
        header="Driver Location"
      >
        <StopInformation>
          <HeaderDetailsItem
            label="Next Stop"
            item={getCityStateNextStop(load?.shipmentInformation)}
          />
          <HeaderDetailsItem
            label="From Most Recent Track to Next Stop"
            item={`${load.milesToNextStop ? `${load.milesToNextStop} miles` : 'N/A'}`}
          />
        </StopInformation>
      </InfoSection>
      <InfoSection removePadding={!!lastTrackingEvent}>
        <Activity
          activity={lastTrackingEvent}
          options={{
            visibilityAppName: load.visibilityAppName,
            noContentMessage: 'No location tracked on this load.',
          }}
        />
      </InfoSection>
    </Card>
  </div>
);

TransitTracker.propTypes = {
  load: loadShape,
  lastTrackingEvent: trackingEventShape,
  refetchLoad: PropTypes.func.isRequired,
};

TransitTracker.defaultProps = {
  load: {
    visibilityAppStatus: 'Installed, Connected',
  },
  lastTrackingEvent: null,
};

export default TransitTracker;
